export const STATUS_CODES = {
	SUCCESS_VALUES: [0, 'SUCCESS'],
	WARNING_VALUES: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 33, 40, 'WARNING'],
};
